// Phone Compatibility Tool v4 — fetches model files from Shopify CDN
// Uses the manufacturers script URL to derive the correct CDN base path

(function() {
  'use strict';

  // Message configuration
  var compatMsgs = {
    0: { type: 'empty', text: '' },
    1: { type: 'success', text: 'Yes! Leitner will work great with your phone.' },
    3: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-mitel-phones" target="_blank">Mitel EHS</a>' },
    4: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-avaya-phones" target="_blank">Avaya EHS</a>' },
    5: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-cisco-phones" target="_blank">Cisco EHS</a>' },
    6: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-grandstream-phones" target="_blank">Grandstream EHS</a>' },
    7: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-avaya-and-shoretel-phones" target="_blank">Avaya/Shoretel EHS</a>' },
    8: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-avaya-phones" target="_blank">Avaya 1400/1600/9000 EHS</a>' },
    9: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-yealink-phones" target="_blank">Leitner Yealink EHS</a>' },
    10: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/remote-handset-lifter-for-leitner-wireless-headset-systems" target="_blank">Leitner Handset Lifter</a>' },
    11: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-polycom-phones" target="_blank">Polycom EHS</a>' },
    12: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/electronic-hookswitch-for-snom-phones" target="_blank">SNOM EHS</a>' },
    13: { type: 'success', text: 'Yes! Leitner will work great with your phone. To add remote answering capabilities, use the <a href="/products/leitner-electronic-hookswitch-for-yealink-phones" target="_blank">Yealink EHS 36</a>' },
    14: { type: 'warning', text: "Hmmm, we're not sure if Leitner will work with your phone. We offer a 60-day money back guarantee in the off chance it doesn't work" },
    15: { type: 'error', text: 'Sorry, Leitner Headsets will not work with your phone' }
  };

  // Resolve the CDN base path from the manufacturers script tag
  var cdnBase = '';
  function getCdnBase() {
    if (cdnBase) return cdnBase;
    var scripts = document.querySelectorAll('script[src*="compat-manufacturers"]');
    if (scripts.length > 0) {
      // Extract base path: everything up to and including the theme ID
      // e.g. https://www.headsets.com/cdn/shop/t/619/assets/compat-manufacturers.js?v=...
      var src = scripts[0].getAttribute('src');
      var baseMatch = src.match(/^(.+\/assets\/).+$/);
      if (baseMatch) {
        cdnBase = baseMatch[1]; // e.g. https://www.headsets.com/cdn/shop/t/619/assets/
        return cdnBase;
      }
    }
    // Fallback: try to find any Shopify CDN asset link
    var links = document.querySelectorAll('link[href*="/cdn/shop/t/"]');
    for (var i = 0; i < links.length; i++) {
      var match = links[i].href.match(/^(.+\/assets\/).+$/);
      if (match) {
        cdnBase = match[1];
        return cdnBase;
      }
    }
    // Last resort
    cdnBase = '/cdn/shop/t/617/assets/';
    return cdnBase;
  }

  function initCompatChecker() {
    var $makeSelect = $('#phone-make-select, #phone-make-select1, #phone-make-select2');
    var $modelSelect = $('.phone-model-select');

    if ($makeSelect.length === 0) return;

    // Populate manufacturer dropdown
    if (typeof window.compatManufacturers !== 'undefined') {
      populateManufacturerDropdown($makeSelect, window.compatManufacturers);
    }

    // Add default + "Mine's not here" options to model dropdown
    $modelSelect.each(function() {
      $(this).empty().append('<option value="">Select Phone Model</option>');
      $(this).append('<option value="not-listed">Mine\'s not here</option>');
    });

    // Keep legacy theme scripts from re-appending old numeric manufacturer options.
    cleanupLegacyManufacturerOptions($makeSelect);
    setTimeout(function() { cleanupLegacyManufacturerOptions($makeSelect); }, 500);
    setTimeout(function() { cleanupLegacyManufacturerOptions($makeSelect); }, 1500);
    setTimeout(function() { cleanupLegacyManufacturerOptions($makeSelect); }, 3000);

    // Manufacturer change handler
    $makeSelect.off('change.compat').on('change.compat', function() {
      var $selected = $(this).find('option:selected');
      var slug = resolveManufacturerSlug($(this).val(), $selected.text());
      var $checker = $(this).closest('.compat-checker');
      var $modelSel = $checker.find('.phone-model-select');

      clearMessages($checker);

      // Reset model dropdown
      $modelSel.find('option').remove();
      $modelSel.append('<option value="">Select Phone Model</option>');
      $modelSel.append('<option value="not-listed">Mine\'s not here</option>');

      if (!slug) return;

      loadManufacturerModels(slug, $modelSel);
    });

    // Model change handler
    $modelSelect.off('change.compat').on('change.compat', function() {
      var val = $(this).val();
      var $checker = $(this).closest('.compat-checker');

      clearMessages($checker);

      if (val === 'not-listed') {
        $checker.find('.compat-not-here').show();
        return;
      }

      if (!val || val === '') return;

      var code = parseInt(val, 10);
      var msg = compatMsgs[code];

      if (!msg || msg.type === 'empty') return;

      showCompatibilityMessage($checker, msg);
    });
  }

  function populateManufacturerDropdown($makeSelect, manufacturers) {
    $makeSelect.each(function() {
      var $sel = $(this);
      $sel.empty().append('<option value="">Select Phone Make</option>');
      $.each(manufacturers, function(i, mfr) {
        $sel.append('<option value="' + mfr.slug + '">' + mfr.name + '</option>');
      });
    });
  }

  function resolveManufacturerSlug(value, label) {
    if (!value) return '';

    var manufacturers = window.compatManufacturers || [];
    for (var i = 0; i < manufacturers.length; i++) {
      if (manufacturers[i].slug === value) return value;
    }

    var normalizedLabel = $.trim(label || '').toLowerCase();
    for (var j = 0; j < manufacturers.length; j++) {
      if ($.trim(manufacturers[j].name || '').toLowerCase() === normalizedLabel) {
        return manufacturers[j].slug;
      }
    }

    return value;
  }

  function cleanupLegacyManufacturerOptions($makeSelect) {
    var manufacturers = window.compatManufacturers || [];
    var validSlugs = {};
    $.each(manufacturers, function(i, mfr) {
      validSlugs[mfr.slug] = true;
    });

    $makeSelect.each(function() {
      var seen = {};
      $(this).find('option').each(function() {
        var value = $(this).val();
        var label = $.trim($(this).text());
        var key = value || '__empty__';

        if (!value) {
          if (seen[key]) $(this).remove();
          seen[key] = true;
          return;
        }

        if (!validSlugs[value]) {
          $(this).remove();
          return;
        }

        if (seen[value] || seen['label:' + label.toLowerCase()]) {
          $(this).remove();
          return;
        }

        seen[value] = true;
        seen['label:' + label.toLowerCase()] = true;
      });
    });
  }

  function loadManufacturerModels(slug, $modelSel) {
    var baseUrl = getCdnBase();
    var scriptUrl = baseUrl + 'compat-models-' + slug + '.js';

    window.compatModels = []; // Reset before loading

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    script.onload = function() {
      var loadedModels = window.compatModels || [];
      var data = loadedModels[loadedModels.length - 1];

      if (data && data.models && data.models.length > 0) {
        $.each(data.models, function(i, model) {
          $modelSel.append('<option value="' + model.c + '">' + model.n + '</option>');
        });
      } else {
        $modelSel.append('<option value="">No models found</option>');
      }

      window.compatModels = [];
      script.remove();
    };

    script.onerror = function() {
      window.compatModels = [];
      $modelSel.append('<option value="">Could not load models</option>');
      script.remove();
    };

    document.head.appendChild(script);
  }

  function clearMessages($checker) {
    $checker.find('.compat-msg-success, .compat-msg-warning, .compat-msg-error').hide().find('span').html('');
    $checker.find('.compat-not-here').hide();
  }

  function showCompatibilityMessage($checker, msg) {
    var selector = '.compat-msg-' + msg.type;
    var $msgEl = $checker.find(selector);
    if ($msgEl.length === 0) return;
    $msgEl.find('span').html(msg.text);
    $msgEl.show();
  }

  $(document).ready(function() {
    initCompatChecker();
  });

})();
